/* eslint-disable */
export default {
  order: 7,
  header: [],
  content: [
    {
      category: '2.1 Release Notes (2020/06/30)',
      description: 'Check out EnOS release notes.',
      url: '',
      isVersionInfo: true,
      item: [
        {
          name: 'EnOS 2.1',
          description: '',
          list: [
            {
              name: 'What’s New?',
              url: '/docs/enos/en/2.1.0/releasenotes/2.1.0_update/new_feature.html'
            },
            {
              name: 'What’s Changed?',
              url: '/docs/enos/en/2.1.0/releasenotes/2.1.0_update/enhancement.html'
            },
            {
              name: 'Known Issues and Limitations',
              url: '/docs/enos/en/2.1.0/releasenotes/knownissue.html'
            }
          ]
        }
      ]
    },
    {
      category: 'EnOS Fundamental',
      description: 'EnOS, an AIoT operating system from Envision Digital that is missioned to enable enterprises and cities to accelerate digital transformation and ecosystem development.  ',
      image: '',
      url: '/docs/enos/en/2.1.0/overview/enos_introduction.html',
      item: [
        {
          name: 'Getting Started',
          description: 'Learn about the advantages and key concepts of EnOS and get started with EnOS quickly.',
          image: '',
          list: [
            {
              name: 'What Is EnOS',
              url: '/docs/enos/en/2.1.0/overview/enos_introduction.html'
            },
            {
              name: 'Getting Started with EnOS',
              url: '/docs/enos/en/2.1.0/getting_started_with_enos/getting_started_with_enos.html'
            },
            {
              name: 'Frequently Asked Questions',
              url: '/docs/enos/en/2.1.0/faq/index.html'
            }
          ]
        },
        {
          name: 'EnOS Management Console',
          description: 'An all-in-one GUI console where IoT engineers, data scientists, and application developers can seamlessly manage the entire IoT life cycle, from device connection, data analysis, to application management and more.',
          image: '',
          list: [
            {
              name: 'Accessing EnOS',
              url: '/docs/enos/en/2.1.0/overview/accessing_enos.html'
            },
            {
              name: 'EnOS Management Console GUI Conventions',
              url: '/docs/enos/en/2.1.0/overview/ui_conventions.html'
            }
          ]
        },
        {
          name: 'Identity and Access Management',
          description: 'Provides user account life cycle management capabilities, where you can control access to resources managed through EnOS. You can centralize the management of user identities and permissions, thereby ensuring the security of your organization’s data.',
          image: '',
          list: [
            {
              name: 'IAM Overview',
              url: '/docs/enos/en/2.1.0/iam/iam_overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/enos/en/2.1.0/iam/iam_gettingstarted_adduser.html'
            },
            {
              name: 'LDAP Federation',
              url: '/docs/enos/en/2.1.0/iam/ldap/index.html'
            }
          ]
        },
        {
          name: 'Resource Management',
          description: 'Provides on-demand management of your resource usages, where you can configure alarms based on resource usages, thereby improving the transparency and utilization of resources.',
          image: '',
          list: [
            {
              name: 'Resource Management on EnOS',
              url: '/docs/enos/en/2.1.0/resourcemanagement/overview.html'
            },
            {
              name: 'Resource Specifications',
              url: '/docs/enos/en/2.1.0/resourcemanagement/reference/index.html'
            },
            {
              name: 'Requesting for Resources',
              url: '/docs/enos/en/2.1.0/resourcemanagement/getstarted.html'
            }
          ]
        },
        {
          name: 'Audit Service',
          description: 'Supports auditing and monitoring of all user operations, user logins, and user logouts, and storing them as historical events in a traceable and unalterable format during the storage period. This helps to enforce data security and compliance for your organization.',
          image: '',
          list: [
            {
              name: 'About Audit',
              url: '/docs/enos/en/2.1.0/audit/audit_overview.html'
            }
          ]
        },
        {
          name: 'Application Registration',
          description: 'Provides convenient management of applications, where application developers can register, purchase, modify, or export applications.',
          image: '',
          list: [
            {
              name: 'Registering and Managing Applications',
              url: '/docs/app-development/en/2.1.0/app_management/managing_apps.html'
            }
          ]
        },
        {
          name: 'EnOS API',
          description: 'APIs and API references are available for all EnOS core business processes, helping to expedite application development and access to system resources.',
          image: '',
          list: [
            {
              name: 'About EnOS API',
              url: '/docs/api/en/2.1.0/overview.html'
            },
            {
              name: 'API Authentication',
              url: '/docs/api/en/2.1.0/authen_overview.html'
            },
            {
              name: 'Get Started with EnOS API',
              url: '/docs/api/en/2.1.0/gettingstarted.html'
            },
            {
              name: 'API Reference',
              url: '/docs/api/en/2.1.0/api_reference.html'
            }
          ]
        },
        {
          name: 'Security',
          description: 'Learn about the security technologies built in EnOS.',
          image: '',
          list: [
            {
              name: 'Security Overview',
              url: '/docs/enos/en/2.1.0/security/security_overview.html'
            },
            {
              name: 'X.509 Certificate Service',
              url: '/docs/enos/en/2.1.0/security/x509_ca/index.html'
            },
            {
              name: 'Identity & Access Management',
              url: '/docs/enos/en/2.1.0/iam/iam_overview.html'
            }
          ]
        },
        {
          name: 'Data Source Registration',
          description: 'Enables centralized registration of internal EnOS data sources and external data sources, so that related product modules can directly access these data sources.',
          image: '',
          list: [
            {
              name: 'Data Source Registration Overview',
              url: '/docs/data-source-reg/en/2.1.0/datasource_overview.html'
            },
            {
              name: 'Registering Data Sources',
              url: '/docs/data-source-reg/en/2.1.0/index.html'
            }
          ]
        }
      ]
    },

    {
      category: 'EnOS Edge',
      description: 'EnOS Edge adapts and accelerates connection through its built-in protocol library, extends cloud intelligence to the edge by providing edge computing and local control to accelerate decision-making and actions. EnOS Edge is software-based and hardware agnostic, offering flexible and cost-effective solutions to meet requirements of different scenarios.',
      image: 'assets/images/EnOS Edge_LIght.png',
      url: '/docs/enos-edge/en/2.1.0/edge_overview.html',
      item: [
        {
          name: '',
          description: '',
          image: '',
          list: [
            {
              name: 'What Is EnOS Edge?',
              url: '/docs/enos-edge/en/2.1.0/edge_overview.html'
            },
            {
              name: 'How to use EnOS Edge?',
              url: '/docs/enos-edge/en/2.1.0/howto/console_configuration/connecting_edge.html'
            },
            {
              name: 'Developer’s Guide',
              url: '/docs/enos-edge/en/2.1.0/howto/developer_guide/app_dev_overview.html'
            },
            {
              name: 'EnOS Edge API',
              url: '/docs/edge-api/en/2.1.0/index.html'
            },
            {
              name: 'Reference',
              url: '/docs/enos-edge/en/2.1.0/reference/protocol_list.html'
            }
          ]
        }
      ]
    },

    {
      category: 'IoT Hub',
      description: 'Provides extensive, secure, and fast connection to heterogeneous sensors, devices, and systems, and device life cycle management.',
      image: 'assets/images/IoT Hub_LIght.png',
      url: '/docs/dcm/en/2.1.0/iot_hub_overview.html',
      item: [
        {
          name: 'Device Connectivity & Management Service',
          description: 'Rapidly access and manage the real-time or historical data of a vast number of diverse devices or systems. The built-in digital twin model library helps to expedite the digital abstraction of industry devices. Manage the entire device life cycle and set up dynamic alert triggers to reduce response time for device anomalies and faults.',
          image: 'assets/images/iothub/Connectivity.png',
          list: [
            {
              name: 'Device Connectivity Service Overview',
              url: '/docs/device-connection/en/2.1.0/device_management_overview.html'
            },
            {
              name: 'Device Modeling',
              url: '/docs/device-connection/en/2.1.0/howto/model/index.html'
            },
            {
              name: 'Alert Management',
              url: '/docs/alert/en/2.1.0/learn/alert_overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/device-connection/en/2.1.0/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: 'API Reference',
              url: '/docs/device-connection/en/2.1.0/reference/api_reference.html'
            }
          ]
        }
      ]
    },

    {
      category: 'Enterprise Data Platform',
      image: 'assets/images/Enterprise Data Platform_LIght.png',
      description: 'Explore the value of data assets, reduce your cost of massive IoT data ownership, and realize the efficient management of device asset data.',
      url: '/docs/data-asset/en/2.1.0/data_asset_overview.html',
      item: [
        {
          name: 'Data Asset Catalog (Preview)',
          description: 'Provides comprehensive data governance of massive amounts of data from different sources, such as centralized classification and management of metadata, efficient querying, and data lineage tracking. Data Asset Catalog helps you to understand the data in your organization and achieve centralized management of data assets.',
          image: 'assets/images/edp/Data_Asset_Catalog.png',
          list: [
            {
              name: 'Data Asset Catalog Overview',
              url: '/docs/data-asset-catalog/en/2.1.0/metadata_explorer.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/data-asset-catalog/en/2.1.0/exploring_metadata.html'
            }
          ]
        },
        {
          name: 'Stream Processing',
          description: 'With the library of common calculators and templates that are accumulated from typical computing scenarios, you can easily develop stream processing and analysis pipelines in a low-code and intuitive drag-and-drop designer.',
          image: 'assets/images/edp/Stream_Processing.png',
          list: [
            {
              name: 'Stream Processing Overview',
              url: '/docs/stream-processing/en/2.1.0/streaming_overview.html'
            },
            {
              name: 'Developing Stream Processing Pipelines',
              url: '/docs/stream-processing/en/2.1.0/dev.html'
            },
            {
              name: 'Stream Processing Pipeline Operation',
              url: '/docs/stream-processing/en/2.1.0/ops.html'
            },
            {
              name: 'API Reference',
              url: '/docs/stream-processing-api/en/2.1.0/overview.html'
            }
          ]
        },
        {
          name: 'Time Series Data Management',
          description: 'A high throughput, high availability, and high compression storage for massive IoT time series data.  The efficient query APIs and visualization tools help you identify and gain insights into your data.',
          image: 'assets/images/edp/Time_Series_Data_Management.png',
          list: [
            {
              name: 'Storage Policy',
              url: '/docs/time-series-data/en/2.1.0/policy.html'
            },
            {
              name: 'Data Insights',
              url: '/docs/time-series-data/en/2.1.0/insights.html'
            },
            {
              name: 'Data Deletion',
              url: '/docs/time-series-data/en/2.1.0/cleanup.html'
            },
            {
              name: 'API Reference',
              url: '/docs/tsdb-data-api/en/2.1.0/overview.html'
            }
          ]
        },
        {
          name: 'Data Federation',
          description: 'A unified data access layer built on top of multi-source heterogeneous data storage systems without moving or synchronizing data. With Data Federation, different data consumers can access data rapidly by using the standard query methods, such as SQL, JDBC, or OData.',
          image: 'assets/images/edp/Data_Federation.png',
          list: [
            {
              name: 'Data Federation Overview',
              url: '/docs/data-federation/en/2.1.0/data_federation_overview.html'
            },
            {
              name: 'Channel Management',
              url: '/docs/data-federation/en/2.1.0/managing_channel.html'
            },
            {
              name: 'Data Read and Write',
              url: '/docs/data-federation/en/2.1.0/reading_writing_data.html'
            },
            {
              name: 'API Reference',
              url: '/docs/data-federation-api/en/2.1.0/overview.html'
            }
          ]
        },
        {
          name: 'Data Subscription',
          description: 'Data subscriptions enable you to push data to applications in real time, improving the efficiency of data acquisition and consumption. Use the SDK provided to enable your applications to subscribe to data efficiently.',
          image: 'assets/images/edp/Data_Subscription.png',
          list: [
            {
              name: 'Data Subscription Overview​',
              url: '/docs/data-subscription/en/2.1.0/data_subscription_overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/data-subscription/en/2.1.0/gettingstarted_subscribe_realtime.html'
            },
            {
              name: 'Consuming Subscribed Data',
              url: '/docs/data-subscription/en/2.1.0/consuming_subscribed_data.html'
            },
            {
              name: 'Data Subscription SDK Reference',
              url: '/docs/data-subscription/en/2.1.0/data_subscription_sdk.html'
            }
          ]
        },
        {
          name: 'Data Archiving',
          description: 'Massive data archiving is performed periodically to ensure that cold data, which is less frequently accessed and takes up a huge amount of storage, is stored in a more economical manner.',
          image: 'assets/images/edp/Data_Archiving.png',
          list: [
            {
              name: 'Data Archiving Overview',
              url: '/docs/data-archiving/en/2.1.0/archive_policy.html'
            },
            {
              name: 'Configuring Data Archiving Jobs',
              url: '/docs/data-archiving/en/2.1.0/configuring_archive_storage.html'
            },
            {
              name: 'Data Archiving Logic',
              url: '/docs/data-archiving/en/2.1.0/archive_storage.html'
            }
          ]
        },
        {
          name: 'Data Synchronization (Preview)',
          description: 'Establish the data transmission channel between external databases and EnOS internal databases to achieve the centralized synchronization and sharing of data and files.',
          image: 'assets/images/edp/Data_Synchronization.png',
          list: [
            {
              name: 'Data Synchronization Overview',
              url: '/docs/data-sync/en/2.1.0/di_overview.html'
            },
            {
              name: 'Synchronizing Data from External Data Source to Hive',
              url: '/docs/data-sync/en/2.1.0/creating_scratch_onetime.html'
            },
            {
              name: 'Synchronizing Data From EnOS Hive to the Target Database',
              url: '/docs/data-sync/en/2.1.0/creating_scratch_hive2mysql.html'
            }
          ]
        },
        {
          name: 'Batch Processing',
          description: 'Enables data developers to process large amounts of data through a visual workflow designer and the stable scheduling service. You can perform calculations, analysis, and gain insights into your data based on data lakes, data warehouses, and application data.',
          image: 'assets/images/edp/Batch_Processing.png',
          list: [
            {
              name: 'Batch Processing Overview​',
              url: '/docs/batch-processing/en/2.1.0/dataide_overview.html'
            },
            {
              name: 'Task Resource Management',
              url: '/docs/batch-processing/en/2.1.0/job_resource/index.html'
            },
            {
              name: 'Workflow Development',
              url: '/docs/batch-processing/en/2.1.0/data_dev/index.html'
            },
            {
              name: 'Workflow Operation',
              url: '/docs/batch-processing/en/2.1.0/task_monitor/index.html'
            }
          ]
        },
        {
          name: 'Data Asset Authorization (Preview)',
          description: 'Data Asset Authorization provides centralized management of access rights of data assets to improve security',
          image: '',
          list: [
            {
              name: 'Data Asset Authorization Overview​',
              url: '/docs/data-asset-auth/en/2.1.0/data_asset_permission.html'
            },
            {
              name: 'Managing Permission Policy',
              url: '/docs/data-asset-auth/en/2.1.0/managing_permission_policy.html'
            }
          ]
        }
      ]
    },

   
    {
      category: 'Application Enablement Platform',
      image: 'assets/images/Application_Enablement_Platform_LIght.png',
      description: 'Provides components, libraries, and services for application development, helping you to build, deploy, and extend applications easily.',
      url: '/docs/app-development/en/2.1.0/app_dev_overview.html',
      item: [
        {
          name: 'Application Development Basics',
          description: 'Based on the application development services and widgets provided by EnOS, quickly start application design, development, deployment, and hosting.',
          image: 'assets/images/aep/Application_Development_Basics.png',
          list: [
            {
              name: 'Registering and Managing Applications',
              url: '/docs/app-development/en/2.1.0/app_management/managing_apps.html'
            },
            {
              name: 'Using EnOS SDKs to Develop',
              url: '/docs/app-development/en/2.1.0/sdk_overview.html'
            },
            {
              name: 'Developing and Publishing APIs',
              url: '/docs/apim/en/2.1.0/api_management_overview.html'
            }
          ]
        },
        {
          name: 'Application Portal',
          description: 'Integrated with EnOS services and data, Application Portal is a web and mobile responsive application framework that helps you to achieve centralized management of application users and access, thereby reducing application development cost and delivering an integrated experience across applications.',
          image: 'assets/images/aep/Application_Portal.png',
          list: [
            {
              name: 'About the Application Portal',
              url: '/docs/app-portal/en/2.1.0/overview.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/app-portal/en/2.1.0/concept.html'
            },
            {
              name: 'Using the Admin Console',
              url: '/docs/app-portal/en/2.1.0/ou_admin/index.html'
            },
            {
              name: 'Application Portal APIs',
              url: '/docs/app-portal-api/en/2.1.0/overview.html'
            }
          ]
        },
        {
          name: 'Digital Twin Visualization',
          description: 'The built-in rich graphic components and low-code platform make it easy for you to build visual applications. You can use a combination of 2D and 3D technologies to enhance the user experience of your monitoring and operation applications.',
          image: 'assets/images/aep/Digital_Twin_Visualization.png',
          list: [
            {
              name: 'Digital Twin Visualization Overview',
              url: '/docs/dtv/en/2.1.0/overview.html'
            },
            {
              name: 'Building Data Dashboard',
              url: '/docs/dtv/en/2.1.0/dtde/index.html'
            }
          ]
        },
        {
          name: 'Notification Management (Preview)',
          description: 'Provides an SMS and email push notification service for EnOS services and applications that are developed on EnOS. This service helps you to centralize the management of all push notifications, improve the reach and delivery of push notifications, and enforce secure push channels. Quota and metering services are also available to help optimize allocation of your resources.',
          image: 'assets/images/aep/Notification_Management.png',
          list: [
            {
              name: 'Notification Management Overview',
              url: '/docs/enos/en/2.1.0/notification_center/notification_center_overview.html'
            }
          ]
        },
        {
          name: 'API Management',
          description: 'Provides secured API life cycle management capabilities to help you grow your business quickly through API integrations.',
          image: 'assets/images/aep/API_Management.png',
          list: [
            {
              name: 'About API Management',
              url: '/docs/apim/en/2.1.0/api_management_overview.html'
            },
            {
              name: 'API Lifecycle Management',
              url: '/docs/apim/en/2.1.0/api_lifecycle_management.html'
            },
            {
              name: 'EnOS APIM Security',
              url: '/docs/apim/en/2.1.0/apim_security.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/apim/en/2.1.0/learn/api_management_quickstart.html'
            }
          ]
        },
        {
          name: 'Application Hosting',
          description: 'Based on Helm Charts, common and reusable components and services can be deployed as templates in just a few clicks.',
          image: 'assets/images/aep/Application_Hosting.png',
          list: [
            {
              name: 'Managing Application Templates',
              url: '/docs/ecp/en/2.1.0/howto/app_hub/managing_app_template.html'
            },
            {
              name: 'Deploying Application Instances',
              url: '/docs/ecp/en/2.1.0/howto/app_hub/deploying_app_instance.html'
            }
          ]
        },
        {
          name: 'Serverless Service',
          description: 'An event-driven function computing service, where resources are allocated and scheduled on a function-level basis so that functions can run in a flexible and reliable manner, thereby enabling you to focus on the business logic of your applications during development.',
          image: 'assets/images/aep/Serverless.png',
          list: [
            {
              name: 'Publishing a Function Application',
              url: '/docs/ecp/en/2.1.0/howto/serverless/managing_function.html'
            }
          ]
        },
        {
          name: 'Single Sign-On Service',
          description: 'Implement a single sign-on service between EnOS and third-party applications by using mainstream standard protocols, solving the problem of having different identity authentication methods for different business applications of your organization.',
          image: 'assets/images/aep/Single_Sign-On_Service.png',
          list: [
            {
              name: 'About Single Sign-On',
              url: '/docs/enos/en/2.1.0/iam/sso/sso_overview.html'
            }
          ]
        },
        {
          name: 'Container Cluster Management',
          description: 'Built on native Kubernetes, this service helps to facilitate the management, deployment, and operation of highly available container clusters.',
          image: 'assets/images/aep/Container_Cluster_Management.png',
          list: [
            {
              name: 'Container Cluster Management Overview',
              url: '/docs/ecp/en/2.1.0/howto/container/index.html'
            }
          ]
        },
        {
          name: 'EnOS HMI',
          description: 'The rich industry graphic component library helps to accelerate the building of asset data visualization and industrial monitoring applications. ',
          image: 'assets/images/aep/EnOS_HMI.png',
          list: [
            {
              name: 'About EnOS HMI',
              url: '/docs/app-development/en/2.1.0/hmi/hmi_overview.html'
            },
            {
              name: 'Deploying and Previewing Monitoring Page',
              url: '/docs/app-development/en/2.1.0/hmi/deploying_graph.html'
            }
          ]
        }
      ]
    }
  ]
};
